import React from 'react';
const variants = {
  active: 'bg-green-100 text-green-700', inactive: 'bg-gray-100',
  present: 'bg-green-100 text-green-700', absent: 'bg-red-100 text-red-700',
  late: 'bg-yellow-100 text-yellow-700', paid: 'bg-green-100 text-green-700',
  partial: 'bg-yellow-100 text-yellow-700', pending: 'bg-red-100 text-red-700',
  completed: 'bg-blue-100 text-blue-700', ongoing: 'bg-indigo-100 text-indigo-700',
  scheduled: 'bg-gray-100', high: 'bg-red-100 text-red-700',
  medium: 'bg-yellow-100 text-yellow-700', low: 'bg-green-100 text-green-700',
  issued: 'bg-blue-100 text-blue-700', overdue: 'bg-red-100 text-red-700',
  returned: 'bg-gray-100', transferred: 'bg-purple-100 text-purple-700',
};
function Badge({ value }) {
  const cls = variants[value?.toLowerCase()] || 'bg-gray-100';
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full font-medium capitalize ${cls}`}>{value}</span>;
}
export default Badge;
